module.exports = __webpack_public_path__ + "static/FuturaPT-Book-8cd2ddc4f8da5b39b5736f3d5025a640.woff2";